
<nb-layout>
    <nb-layout-column>

<main>

<h3>Add new painting</h3>


 <button nbButton nbButton size="small" class="add" routerLink="/new-painting">Add </button>

<h3>Paintings</h3>

<table>
<thead>
    <th>Nb</th>
    <th>Name</th>
    <th>Dimensions</th>
    <th>Edit</th>
    <th>Delete</th>
</thead>
<tbody class="card-container">
    <tr class="card" *ngFor="let painting of paintings; let i = index">
        <td>{{i+1}}</td>
        <td>{{painting.name}}</td>
        <td>{{painting.dimensions}}</td>
        <td><button  nbButton size="small" outline (click)="toEdit(painting.id)">Edit <nb-icon icon="edit">
                </nb-icon>
            </button></td>
        <td><button nbButton size="small" class='delete'(click)="toDelete(painting.id)">Delete <nb-icon icon="close">
                    </nb-icon>
                </button></td>

       
    </tr>
</tbody>


</table>

</main>
</nb-layout-column>
</nb-layout>


